import { EditableComponent } from '@adobe/aem-react-editable-components';
import dynamic from 'next/dynamic';

const WishListLandingComp = dynamic(() => import('./WishListLanding').then(mod => mod.WishListLanding));

export const WishlistLandingConfig = {
  emptyLabel: 'wishlistlanding',
  isEmpty: false,
  resourceType: `mi-aem-account/components/content/wishlistLanding`,
};
/* eslint-disable @typescript-eslint/no-explicit-any */
export const WishlistLandingEditable = (props: any) => (
  <EditableComponent config={WishlistLandingConfig} {...props}>
    <WishListLandingComp {...props} />
  </EditableComponent>
);
